export interface TelegramAccountBrandingProps {
  telegramAccountUUID: string
  firstName: string
  lastName: string
  about: string
  avatarUrl: string | null
  loadedFromCache: boolean
}

export class TelegramAccountBrandingEntity {
  private readonly props: TelegramAccountBrandingProps
  private constructor(props: TelegramAccountBrandingProps) { this.props = { ...props } }
  static create(props: TelegramAccountBrandingProps) { return new TelegramAccountBrandingEntity(props) }
  get telegramAccountUUID() { return this.props.telegramAccountUUID }
  get firstName() { return this.props.firstName }
  get lastName() { return this.props.lastName }
  get about() { return this.props.about }
  get avatarUrl() { return this.props.avatarUrl }
  get loadedFromCache() { return this.props.loadedFromCache }
}
